// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-picker {\n  display: flex;\n  flex-direction: row;\n  border: 1px solid var(--grey);\n  font-size: 24px;\n  align-items: baseline;\n  width: fit-content;\n}\n\n.time-picker.disabled {\n  opacity: 0.5;\n}\n\n.form-container .time-picker input[type=\"number\"],\n.time-picker input[type=\"number\"] {\n  user-select: all;\n  max-width: 50px;\n  background-color: var(--dark-grey);\n  color: white;\n  text-align: center;\n  font-size: 16px;\n  margin: 0;\n  width: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
